import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import firebase from "../../Firebase";
import { Button } from "reactstrap";
import matchSorter from "match-sorter";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import Modal from "react-modal";
import downloadFile from "../../utils/downloadFile";
import { normalizeFiles } from "../../utils/fileList";
import CorteRegistroModal from "../UserPage/corte/CorteRegistroModal";

const renderTitledCell = (row) => <span title={row.value}>{row.value}</span>;

// Renderiza N archivos. Separado de renderFileIconCell a proposito: ese lo
// comparten `cx` (proforma) y `b` (ficha tecnica), que estan fuera de alcance.
const renderMultiFileCell = (row, legacyNameKey, icono) => (
  <div style={{ display: "flex", flexWrap: "wrap" }}>
    {normalizeFiles(row.value, row.original[legacyNameKey]).map((f, i) => (
      <a
        key={i}
        href={f.url}
        title={f.name}
        style={{ marginRight: "4px" }}
        onClick={(e) => {
          e.preventDefault();
          downloadFile(f.url, f.name);
        }}
      >
        <img src={icono} style={{ width: "16px" }} alt={f.name} />
      </a>
    ))}
  </div>
);

const ICONO_PDF =
  "https://cdn3.iconfinder.com/data/icons/muksis/128/pdf-128.png";
const ICONO_ZIP =
  "https://cdn3.iconfinder.com/data/icons/muksis/128/zip-128.png";

const renderFileIconCell = (row) => {
  const url = Array.isArray(row.value) ? row.value[0] : row.value;
  return (
    <div>
      {url ? (
        <span
          style={{
            width: "10px",
            height: "100%",
          }}
        >
          <a href={url} target="_blank" rel="noopener noreferrer">
            <img
              src="https://cdn3.iconfinder.com/data/icons/muksis/128/pdf-128.png"
              style={{ width: "16px" }}
              alt=""
            />
          </a>
        </span>
      ) : null}
    </div>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "10px",
    backgroundColor: "#c8dad3",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

class RegularTables extends React.Component {
  constructor() {
    super();
    this.state = {
      datos: [],
      op: [],
      ft: [],
      loading: true,
      modalIsOpen: false,
      password: "",
      ordenPedido: "",
      color: "",
      cantidad: null,
      doc: "",
      fechaIngreso: null,
      hc: [],
      costuraData: [],
      corteModalIsOpen: false,
      corteModalData: null,
      expanded: {},
    };
  }

  async loadData() {
    await firebase
      .firestore()
      .collection("corte")
      .orderBy("order", "desc")
      .get()
      .then((querySnapshot) => {
        //let datos = [];
        const data = querySnapshot.docs.reduce((acc, data) => {
          const item = data.data();
          const itemIndex = acc.findIndex((accItem) => accItem.op === item.op);
          const cantidadPCP = item.cantidad;
          const {
            fechaIngreso,
            cantidad,
            fechaIngreso2,
            cantidad2,
            servicio,
            total,
            tizadoUrl,
            tizadoName,
          } =
            item.otros && item.otros.length
              ? item.otros[0]
              : {
                  fechaIngreso: null,
                  cantidad: null,
                  fechaIngreso2: null,
                  cantidad2: null,
                  servicio: null,
                  total: null,
                  tizadoUrl: null,
                  tizadoName: null,
                };
          const cantidad1 = cantidad;
          const fechaCorte2 = fechaIngreso2;
          const fechaCorte1 = fechaIngreso;

          let newItem = [{}];
          if (itemIndex >= 0) {
            newItem = {
              ...acc[itemIndex],
              otros: acc[itemIndex].otros.concat({
                color: item.color,
                cantidadPCP: cantidadPCP,
                estado: [item.estado.concat(cantidadPCP, cantidad1)],
                edit: [
                  item.index,
                  item.op,
                  item.color,
                  item.estado && item.estado.length ? item.estado[0] : "",
                  !item.isEditable,
                  cantidadPCP,
                  cantidad1,
                  cantidad2,
                  fechaCorte1,
                  fechaCorte2,
                  tizadoUrl,
                  tizadoName,
                ],
                index: item.estado.concat(item.index, !item.isEditable, [
                  item.estado.concat(cantidadPCP, cantidad1),
                ]),
                fechaCorte1: fechaCorte1,
                servicio: servicio,
                cantidad1: cantidad1,
                fechaIngreso2: fechaCorte2,
                cantidad2: cantidad2,
                total: total,
                tizadoUrl: tizadoUrl,
                tizadoName: tizadoName,
              }),
            };
            acc.splice(itemIndex, 1, newItem);
          } else {
            newItem = {
              fechaIngreso: item.fechaIngreso,
              op: item.op,
              cx: item.cx,
              ft: item.ft,
              b: item.b,
              hc: item.hc,
              hojaConsumo: item.hojaConsumo,
              moldes: item.moldes,
              moldesUrl: item.moldesUrl,
              tizadoDdp: item.tizadoDdp,
              tizadoDdpUrl: item.tizadoDdpUrl,
              descripcion: item.descripcion,
              otros: [
                {
                  color: item.color,
                  cantidadPCP: cantidadPCP,
                  estado: [item.estado.concat(cantidadPCP, cantidad1)],
                  edit: [
                    item.index,
                    item.op,
                    item.color,
                    item.estado && item.estado.length ? item.estado[0] : "",
                    !item.isEditable,
                    cantidadPCP,
                    cantidad1,
                    cantidad2,
                    fechaCorte1,
                    fechaCorte2,
                    tizadoUrl,
                    tizadoName,
                  ],
                  index: item.estado.concat(item.index, !item.isEditable, [
                    item.estado.concat(cantidadPCP, cantidad1),
                  ]),
                  fechaCorte1: fechaCorte1,
                  servicio: servicio,
                  cantidad1: cantidad1,
                  fechaIngreso2: fechaCorte2,
                  cantidad2: cantidad2,
                  total: total,
                  tizadoUrl: tizadoUrl,
                  tizadoName: tizadoName,
                },
              ],
            };
            acc.push(newItem);
          }

          return acc;
        }, []);
        this.setState({ data, loading: false });
      })
      .catch((error) => {
        console.error("Error getting documents: ", error);
      });
  }
  componentDidMount() {
    this.loadData();
  }

  openModal(value) {
    this.setState({
      modalIsOpen: true,
      doc: value[0],
      ordenPedido: value[1],
      colorState: value[2],
      estado: value[3],
      isEditable: value[4],
      cantidadPCP: value[5],
      cantidad1: value[6],
      cantidad2: value[7],
      fechaCorte1: value[8],
      fechaIngreso2: value[9],
      tizadoUrl: value[10],
      tizadoName: value[11],
    });
  }

  closeModal(e) {
    e.preventDefault();
    this.setState({ modalIsOpen: false });
  }

  openCorteModal = (original) => {
    this.setState({
      corteModalIsOpen: true,
      corteModalData: {
        docId: original.edit[0],
        op: original.edit[1],
        color: original.edit[2],
        estado: original.estado[0][0],
        cantidadPCP: original.cantidadPCP,
        cantidad1: original.cantidad1,
        fechaCorte1: original.fechaCorte1,
        cantidad2: original.cantidad2,
        fechaIngreso2: original.fechaIngreso2,
        tizadoUrl: original.tizadoUrl,
        tizadoName: original.tizadoName,
      },
    });
  };

  closeCorteModal = () => {
    this.setState({ corteModalIsOpen: false });
  };

  linkToEdit = (e) => {
    e.preventDefault();
    if (this.state.password !== "pcpedit246.") {
      alert("Wrong password, try again");
      return;
    }
    this.setState({ modalIsOpen: false, password: "" });
    this.setState({
      corteModalIsOpen: true,
      corteModalData: {
        docId: this.state.doc,
        op: this.state.ordenPedido,
        color: this.state.colorState,
        estado: this.state.estado,
        cantidadPCP: this.state.cantidadPCP,
        cantidad1: this.state.cantidad1,
        fechaCorte1: this.state.fechaCorte1,
        cantidad2: this.state.cantidad2,
        fechaIngreso2: this.state.fechaIngreso2,
        tizadoUrl: this.state.tizadoUrl,
        tizadoName: this.state.tizadoName,
      },
    });
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  borrar = (value) => {
    const op = value[1];
    const col = value[2];
    const id = value[3];
    const newEstado = value[value.length - 1]
      .slice(0, value[value.length - 1].length - 1)
      .concat(0)
      .map((item, idx) => (idx === 0 ? (item = "Nuevo") : item));

    const estado = value
      .slice(0, 3)
      .map((item, idx) => (idx === 0 ? (item = "Nuevo") : item));

    firebase
      .firestore()
      .collection("corte")
      .doc(id)
      .update({
        isEditable: true,
        estado,
        otros: [],
      });

    firebase
      .firestore()
      .collection("telas")
      .where("op", "==", op)
      .where("color", "==", col)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("telas")
            .doc(doc.id)
            .update({
              isEditable: true,
            });
        });
      });

    const dataUpdated = this.state.data.map((item) => {
      if (item.op === op) {
        const otros = item.otros;
        const index = otros.findIndex((item) => item.color === col);
        otros.splice(index, 1, {
          ...otros[index],
          fechaCorte1: "",
          servicio: "",
          cantidad1: "",
          fechaIngreso2: "",
          cantidad2: "",
          total: "",
          estado: [newEstado],
          index: estado.concat(id),
          edit: [id, op, col, estado, true],
          otros: [],
        });
      }
      return item;
    });
    this.setState({ data: dataUpdated });

    firebase
      .firestore()
      .collection("comercial")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          firebase
            .firestore()
            .collection("comercial")
            .doc(doc.id)
            .update({
              otros: doc.data().otros.map((v) => {
                if (v.color === col) {
                  delete v.corte;
                  return v;
                }
                return v;
              }),
            });
        });
      });

    firebase
      .firestore()
      .collection("ing")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const status = "Rotulado";
          firebase
            .firestore()
            .collection("ing")
            .doc(doc.id)
            .update({
              otros: doc.data().otros.map((v) => {
                if (v.color === col) {
                  return {
                    ...v,
                    status: [status],
                  };
                }
                return v;
              }),
            });
        });
      });

    try {
      firebase
        .firestore()
        .collection("costura")
        .where("op", "==", op)
        .where("color", "==", col)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            firebase
              .firestore()
              .collection("costura")
              .doc(doc.id)
              .delete();
          });
        });
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  render() {
    const { data, loading } = this.state;
    const mainCorte = [
      {
        headerStyle: { backgroundColor: "#9C9A96", color: "white" },
        columns: [
          {
            Header: "Fecha Telas",
            width: 110,
            headerStyle: { fontWeight: "bold" },
            accessor: "fechaIngreso",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "fechaIngreso",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "Orden de Producción(OP)",
            width: 200,
            headerStyle: { fontWeight: "bold" },
            accessor: "op",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "op" }],
              }),
            filterAll: true,
          },
          {
            Header: "",
            accessor: "cx",
            width: 30,
            Cell: renderFileIconCell,
          },
          {
            Header: "Ficha Tecnica",
            headerStyle: { fontWeight: "bold" },
            width: 150,
            accessor: "ft",
            style: { textAlign: "left" },
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "ft" }],
              }),
            filterAll: true,
            Cell: renderTitledCell,
          },
          {
            Header: "",
            accessor: "b",
            width: 30,
            Cell: renderFileIconCell,
          },
          {
            Header: "Hoja Consumo",
            headerStyle: { fontWeight: "bold" },
            width: 150,
            accessor: "hojaConsumo",
            style: { textAlign: "left" },
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "hojaConsumo",
                  },
                ],
              }),
            filterAll: true,
            Cell: renderTitledCell,
          },
          {
            Header: "",
            accessor: "hc",
            width: 80,
            Cell: (row) => renderMultiFileCell(row, "hojaConsumo", ICONO_PDF),
          },
          {
            Header: "Moldes",
            headerStyle: { fontWeight: "bold" },
            width: 150,
            accessor: "moldes",
            style: { textAlign: "left" },
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "moldes",
                  },
                ],
              }),
            filterAll: true,
            Cell: renderTitledCell,
          },
          {
            Header: "",
            accessor: "moldesUrl",
            width: 80,
            Cell: (row) => renderMultiFileCell(row, "moldes", ICONO_ZIP),
          },
          {
            Header: "Tizado DDP",
            headerStyle: { fontWeight: "bold" },
            width: 150,
            accessor: "tizadoDdp",
            style: { textAlign: "left" },
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "tizadoDdp",
                  },
                ],
              }),
            filterAll: true,
            Cell: renderTitledCell,
          },
          {
            Header: "",
            accessor: "tizadoDdpUrl",
            width: 80,
            Cell: (row) => renderMultiFileCell(row, "tizadoDdp", ICONO_ZIP),
          },
          {
            Header: "Descripcion",
            headerStyle: { fontWeight: "bold" },
            minWidth: 272,
            accessor: "descripcion",
            style: { textAlign: "left" },
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "descripcion",
                  },
                ],
              }),
            filterAll: true,
            Cell: renderTitledCell,
          },
        ],
      },
    ];

    const subCorte = [
      {
        Header: "Color",
        headerStyle: { fontWeight: "bold" },
        width: 170,
        accessor: "color",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [
              { threshold: matchSorter.rankings.CONTAINS, key: "color" },
            ],
          }),
        filterAll: true,
      },
      {
        Header: "Cantidad PCP",
        headerStyle: { fontWeight: "bold" },
        width: 120,
        accessor: "cantidadPCP",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [
              { threshold: matchSorter.rankings.CONTAINS, key: "cantidad" },
            ],
          }),
        filterAll: true,
      },
      {
        Header: "Servicio",
        headerStyle: { fontWeight: "bold" },
        accessor: "servicio",
      },
      {
        Header: "Tizado",
        headerStyle: { fontWeight: "bold" },
        accessor: "tizadoName",
        width: 150,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [
              {
                threshold: matchSorter.rankings.CONTAINS,
                key: "tizadoName",
              },
            ],
          }),
        filterAll: true,
        Cell: (row) => {
          const tizados = normalizeFiles(
            row.original.tizadoUrl,
            row.original.tizadoName
          );
          return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", overflow: "hidden" }}>
              <span
                title={row.value}
                style={{
                  marginRight: tizados.length ? "5px" : "0",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  minWidth: 0,
                  flexShrink: 1,
                }}
              >
                {row.value}
              </span>
              {tizados.map((f, i) => (
                <span
                  key={i}
                  style={{ width: "16px", flexShrink: 0, height: "100%", marginRight: "4px" }}
                >
                  <a
                    href={f.url}
                    title={f.name}
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile(f.url, f.name);
                    }}
                  >
                    <img
                      src="https://cdn3.iconfinder.com/data/icons/muksis/128/zip-128.png"
                      style={{ width: "16px" }}
                      alt={f.name}
                    />
                  </a>
                </span>
              ))}
            </div>
          );
        },
      },
      {
        Header: "Corte 1",
        headerStyle: {
          backgroundColor: "#F1EFE8",
          color: "#2C2C2A",
          fontWeight: "bold",
        },
        columns: [
          {
            Header: "Fecha",
            headerStyle: { fontWeight: "bold" },
            accessor: "fechaCorte1",
          },
          {
            Header: "Cantidad",
            headerStyle: { fontWeight: "bold" },
            accessor: "cantidad1",
          },
        ],
      },
      {
        Header: "Corte 2",
        headerStyle: {
          backgroundColor: "#F1EFE8",
          color: "#2C2C2A",
          fontWeight: "bold",
        },
        columns: [
          {
            Header: "Fecha",
            headerStyle: { fontWeight: "bold" },
            accessor: "fechaIngreso2",
          },
          {
            Header: "Cantidad",
            headerStyle: { fontWeight: "bold" },
            accessor: "cantidad2",
          },
        ],
      },
      {
        Header: "Total Corte",
        headerStyle: { fontWeight: "bold" },
        accessor: "total",
        Cell: (row) => {
          const estadoActual =
            row.original.estado &&
            row.original.estado[0] &&
            row.original.estado[0][0];
          if (!estadoActual || estadoActual === "Nuevo" || row.value == null) {
            return null;
          }
          const cantidadPCP = Number(row.original.cantidadPCP) || 0;
          const total = Number(row.value) || 0;
          const diff = total - cantidadPCP;
          if (!cantidadPCP || diff === 0) {
            return <span>{total}</span>;
          }
          return (
            <span>
              {total}{" "}
              <span
                style={{
                  color: diff < 0 ? "#EB5757" : "#219653",
                  fontWeight: "bold",
                }}
              >
                ({diff > 0 ? "+" : ""}
                {diff})
              </span>
            </span>
          );
        },
      },
      {
        Header: "Estado",
        headerStyle: { fontWeight: "bold" },
        width: 140,
        accessor: "estado",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [
              {
                threshold: matchSorter.rankings.STARTS_WITH,
                key: "estado",
              },
            ],
          }),
        filterAll: true,
        Cell: (row) => {
          const estado = row.value[0][0];
          const colors = {
            Nuevo: "#2D9CDB",
            "En Curso": "#F2C94C",
            Listo: "#219653",
          };
          return (
            <div className="text-center">
              <span
                style={{
                  display: "inline-block",
                  backgroundColor: colors[estado] || "#9C9A96",
                  borderRadius: "10px",
                  padding: "5px 14px",
                  color: "white",
                  whiteSpace: "nowrap",
                  fontSize: "12px",
                  lineHeight: "16px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                {estado}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Acción",
        accessor: "edit",
        width: 120,
        headerStyle: { fontWeight: "bold" },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["edit"] }),
        filterAll: true,
        Cell: (row) => {
          const estado = row.value[3];
          const label = estado === "Listo" ? "Editar" : "Registrar";
          return (
            <div className="text-center">
              <Button
                style={{
                  backgroundColor: estado === "Listo" ? "orange" : "#2D9CDB",
                  width: "92px",
                  textAlign: "center",
                  borderRadius: "10px",
                  color: "white",
                  fontWeight: "bold",
                  margin: "0px",
                  padding: "5px",
                  whiteSpace: "nowrap",
                }}
                disabled={row.value[4] ? true : false}
                onClick={() =>
                  estado === "Listo"
                    ? this.openModal(row.value)
                    : this.openCorteModal(row.original)
                }
              >
                {label}
              </Button>
            </div>
          );
        },
      },
      {
        Header: "Borrar",
        headerStyle: { fontWeight: "bold" },
        width: 100,
        accessor: "index",
        Cell: (row) => (
          <div className="text-center">
            {row.value ? (
              <Button
                style={{
                  backgroundColor: "red",
                  width: "92px",
                  textAlign: "center",
                  borderRadius: "10px",
                  color: "white",
                  margin: "0px",
                  padding: "5px",
                }}
                disabled={
                  row.value[0] === "Nuevo" || row.value[4] ? true : false
                }
                onClick={(e) =>
                  window.confirm("ESTAS SEGURO QUE QUIERES BORRAR?") &&
                  this.borrar(row.value)
                }
                type="button"
              >
                Borrar
              </Button>
            ) : (
              ""
            )}
          </div>
        ),
      },
    ];

    return (
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="text-center">
                  Produccion de Procesos de Corte
                </CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={data}
                  filterable
                  defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value
                  }
                  columns={mainCorte}
                  noDataText="Sin Registros"
                  loading={loading}
                  loadingText="POR FAVOR, ESPERE UN MOMENTO"
                  defaultPageSize={10}
                  style={{ textAlign: "center" }}
                  previousText="Atras"
                  nextText="Siguiente"
                  pageText="Pagina"
                  ofText="de"
                  minRows={0}
                  rowsText="filas"
                  expanded={this.state.expanded}
                  onExpandedChange={(newExpanded) =>
                    this.setState({ expanded: newExpanded })
                  }
                  SubComponent={(row) => {
                    return (
                      <div className="subcorte-table" style={{ padding: "10px 10px 30px 10px" }}>
                        <ReactTable
                          data={row.original.otros}
                          columns={subCorte}
                          noDataText="Ingrese un registro en Corte"
                          pageSize={row.original.otros.length}
                          showPagination={false}
                          style={{
                            textAlign: "center",
                            margin: "10px 0 35px 0",
                          }}
                        />
                      </div>
                    );
                  }}
                />
                <br />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <h2>Enter a password</h2>
          <form>
            <input
              type="password"
              value={this.state.password}
              name="password"
              onChange={this.onChange}
              style={{ border: "1px solid black" }}
            />

            <button
              onClick={(e) => this.linkToEdit(e)}
              autoFocus
              style={{
                borderRadius: "5px",
                padding: "2px",
                margin: "10px",
                backgroundColor: "#58b368",
                border: "2px solid black",
                cursor: "pointer",
              }}
            >
              Submit
            </button>
            <button
              onClick={(e) => this.closeModal(e)}
              style={{
                borderRadius: "5px",
                padding: "2px",
                margin: "10px",
                backgroundColor: "#ca3e47",
                border: "2px solid black",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </form>
        </Modal>
        <CorteRegistroModal
          isOpen={this.state.corteModalIsOpen}
          onClose={this.closeCorteModal}
          onSaved={() => this.loadData()}
          {...(this.state.corteModalData || {})}
        />
      </div>
    );
  }
}

export default RegularTables;
